<style lang="scss" scoped>
.offer-already-sent-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 500;
    cursor: pointer;
}
</style>

<template>
    <div>
        <day-configurator-header />
        <day-configurator-new v-if="$route.name === 'empty-configurator'"></day-configurator-new>
        <router-view v-else :key="$route.fullPath" />

        <div v-if="offerAlreadySent" class="offer-already-sent-overlay" @click.prevent="duplicateSchedule"></div>
    </div>
</template>

<script>
export default {
    name: 'day-configurator',

    props: {
        translations: {
            type: Object,
            required: true,
            default: () => {
                return {}
            }
        }
    },

    data: () => ({
        offerAlreadySent: false,
        toast: null
    }),

    mounted() {
        const self = this;
        let schedule = this.$store.getters['dayConfigurator/schedule'];

        if (schedule.has_offer && this.$route.name !== 'configurator-detail-public') {
            this.offerAlreadySent = true;
            setTimeout(function () {
                self.toast = self.$toasted.show(self.translations.day_planning.offer_already_sent, {
                    action: {
                        text: 'Sluiten',
                        onClick: (e, toastObject) => {
                            self.duplicateSchedule();
                        }
                    }
                });
            }, 500);
        };
    },

    created() {
        this.$store.dispatch('dayConfigurator/initTranslations', this.translations)
    },

    methods: {
        duplicateSchedule() {
            let schedule = this.$store.getters['dayConfigurator/schedule'];
            this.$store.dispatch('dayConfigurator/duplicate', schedule).then(() => {
                this.toast.goAway(0);
                this.offerAlreadySent = false;

                if (history.pushState) {
                    history.pushState({}, null, this.$store.getters['dayConfigurator/schedule'].id)
                }
            });
        }
    }
}
</script>